import Vue from "vue";
import Router from "vue-router";

import Home from "@/components/HomeView/index";
import Schedule from "@/components/ScheduleView/index";
import History from "@/components/HistoryView/index";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/schedule",
      name: "Schedule",
      beforeEnter(to, from, next) {
        window.location = "https://horaro.org/trm/seven";
      },
    },
    {
      path: "/history",
      name: "History",
      component: History,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js